<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="change-payment-method">
        <span class="title change-payment-method__title"> Change payment method </span>
        <div class="change-payment-method__card">
          <div class="change-payment-method__head">Card</div>
          <div class="change-payment-method__card-list">
            <custom-input
              @input-event="inputChange"
              input-name="payment-method"
              input-type="radio"
              input-value="card"
              input-id="card"
              :initial-value="store.state.paymentInstrumentType.toLowerCase()"
              v-if="store.state.cardDetails.lastFourDigits && cardLogo"
            >
              <template v-slot:label-content>
                <img class="change-payment-method__card-logo" :src="cardLogo" alt="card-logo" />
                <span class="change-payment-method-card-number"
                  ><span>**** ****</span> {{ store.state.cardDetails.lastFourDigits || 1111 }}</span
                >
              </template>
            </custom-input>
          </div>
        </div>
        <div class="change-payment-method__bank">
          <div class="change-payment-method__head">Bank</div>
          <div class="change-payment-method__bank-list">
            <custom-input
              @input-event="inputChange"
              input-name="payment-method"
              input-type="radio"
              input-value="wallet"
              input-id="bank"
              :initial-value="store.state.paymentInstrumentType.toLowerCase()"
            >
              <template v-slot:label-content>
                <div class="change-payment-method__bank--details">
                  <span class="change-payment-method__bank-name">Carbon account</span>
                  <div class="change-payment-method__bank-balance">
                    {{
                      moneyFormatter(walletBallance, {
                        countryCode: 'ng',
                        showEmptyDecimal: false,
                        displayCurrencyAs: 'symbol',
                        officialLanguage: 'en'
                      })
                    }}
                  </div>
                </div>
              </template>
            </custom-input>
          </div>
        </div>

        <div class="change-payment-method__save-button btn btn__primary btn--lg">
          <button @click="changePaymentMethod">Save</button>
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'

import Popup from '@/components/cards/popup/index.vue'
import CustomInput from '@/components/custom-radio-or-check-input/index.vue'

import store from '@/composables/useZeroWidgetStore/methods'
import { userCardIcon, moneyFormatter } from '@/composables/useUtilities'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}
const cardLogo: any = ref('')

const paymentInstrumentType = ref('')

const inputChange = (target: HTMLInputElement) => {
  const paymentInstrumentSelected = target.value.toUpperCase()
  paymentInstrumentType.value = paymentInstrumentSelected
}

const changePaymentMethod = () => {
  store.actions.setPaymentInstrumentType(paymentInstrumentType.value)
  store.actions.setComponent('review-payment')
}
const walletBallance = ref(0)
onBeforeMount(async () => {
  walletBallance.value = store.state.walletDetails.balance
  store.actions.getCardDetails()
  cardLogo.value = JSON.parse(JSON.stringify(await userCardIcon(store.state.cardDetails.brand))).default
})
</script>
<style lang=""></style>
